<script setup>
  import {onMounted, ref, watch} from "vue";

  defineOptions({
    name: "ComponentSwitch",
  });

  const props = defineProps({
    label: {
      type: String,
      default: "",
    },
    modelValue: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  });

  const emit = defineEmits(["input", "changed", "update:modelValue"]);

  const currentValue = ref(null);

  watch(
    () => props.modelValue,
    (newValue) => {
      currentValue.value = newValue;
    },
  );

  onMounted(() => {
    currentValue.value = props.modelValue;
  });

  const handleChange = () => {
    currentValue.value = !currentValue.value;

    emit("update:modelValue", currentValue.value);
    emit("input", currentValue.value);
    emit("changed", {label: props.label, value: currentValue.value});
  };
</script>

<template>
  <div class="flex items-center">
    <button
      type="button"
      :class="{'bg-mcred': !currentValue, 'bg-mcgreen': currentValue}"
      role="switch"
      aria-checked="false"
      aria-labelledby="annual-billing-label"
      :disabled="disabled"
      @click="handleChange"
    >
      <span
        aria-hidden="true"
        class="pointer-events-none inline-block size-5 rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out"
        :class="{'translate-x-5': !currentValue, 'translate-x-0': currentValue}"
      />
    </button>

    <span class="ml-2" :class="{'text-gray-500': disabled}">{{ label }}</span>
  </div>
</template>
